<template>
  <div id="register">
    <div class="login-container container-fluid p-0 m-0 justify-content-center d-flex flex-column align-items-center">
      <div class="row w-100">
        <div class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-10 offset-1">
          <div class="cotizarlo-general-wrapper" v-if="!isGoogleUser">
            <div class="card-body px-xl-5 px-lg-5 px-md-5 px-sm-3 px-2 pt-xl-5 pt-lg-5 pt-md-5 pt-sm-3 pt-2  pb-4">
              <form>
                <div class="row mb-1">
                  <div class="col-12 text-center">
                    <img src="@/assets/logo.svg" class="img-fluid" style="max-height:50px !important;"/>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-12 text-center">
                    <span style="color:#0C203D"><b>¡Bienvenido! Crea tu cuenta:</b></span>
                  </div>
                </div>
                <!-- Campos de formulario -->
                <div class="row mt-4">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.normal_register.email.$error }">
                        <i class="icon-input icon-cot-usuario"></i>
                        <input placeholder ="_" class="main-input icon" type="email"  id="email" v-model="normal_register.email" autocomplete="new_email" required/>
                        <label class="main-label icon" for="email">E-mail*</label>
                      </div>
                      <small class="form-text text-danger mt-1" v-show="!$v.normal_register.email.email">Ingresa un email válido.</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.normal_register.name.$error }">
                        <input placeholder ="_" type="text" class="main-input" id="name" v-model="normal_register.name" autocomplete="new_name" required/>
                        <label class="main-label" for="name">Nombre*</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pl-xl-0 pl-lg-0">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.normal_register.last_name.$error }">
                        <input placeholder ="_" type="text"  class="main-input" id="last_name" v-model="normal_register.last_name" autocomplete="new_last_name" required/>
                        <label class="main-label" for="last_name">Apellidos*</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.normal_register.password.$error }">
                        <i class="icon-input icon-cot-bloqueado"></i>
                        <input placeholder="_" type="password" class="main-input icon" id="password" v-model="normal_register.password" autocomplete="new_password" required/>
                        <label class="main-label icon" for="password">Contraseña*</label>
                      </div>
                      <small class="form-text text-danger" v-show="!$v.normal_register.password.minLength">La contraseña debe ser de al menos 6 caractéres</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.normal_register.verify.$error }">
                        <i class="icon-input icon-cot-bloqueado"></i>
                        <input type="password" class="main-input icon" id="verify" v-model="normal_register.verify" placeholder="_" autocomplete="new_verify" required/>
                        <label class="main-label icon" for="verify">Verificar contraseña*</label>
                      </div>
                      <small class="form-text text-danger" v-show="$v.normal_register.password.minLength && !$v.normal_register.verify.sameAsPassword">No coincide la contraseña</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-field login">
                        <i class="icon-input far fa-building"></i>
                        <input placeholder="_" type="text" id="company" v-model="normal_register.company" class="main-input icon" autocomplete="new_company" />
                        <label class="main-label icon" for="company">Nombre de empresa</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <hollow-dots-spinner v-if="loadingCountries" dark style="height: 25px; margin: 15px auto;" />
                      <div v-else class="input-field login" :class="{ 'is-invalid': $v.normal_register.country_id.$error }">
                        <i class="icon-input far fa-map"></i>
                        <select id="country" v-model="normal_register.country_id" class="main-input icon" required :disabled="loadingCountries">
                          <option disabled selected :value="null">Selecciona pais</option>
                          <option v-for="country in countries" :key="'country-' + country.id" :value="country.id">{{ country.name }}</option>
                        </select>
                        <label class="main-label icon" for="country">Pais*</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group form-check">
                      <input type="checkbox" class="form-check-input" :class="{'is-invalid': $v.normal_register.terms.$error}"  id="terms" v-model="normal_register.terms">
                      <label class="cot-reg-check-label" for="terms">
                        Al crear tu cuenta aceptas plenamente los 
                        <a href="https://www.cotizarlo.com/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a> 
                        así como nuestro 
                        <a href="https://www.cotizarlo.com/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <button type="button" class="btn form-control cot-login-btn" @click="doRegister()" :disabled="!normal_register.terms || loadingRegister">
                      <hollow-dots-spinner v-if="loadingRegister" />
                      <span v-else>Crear cuenta</span>
                    </button>
                  </div>
                </div>

                <div class="row my-2">
                  <div class="col text-center">
                    <small class="text-login">o</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center" style="cursor:pointer;" @click="doRegisterSocial()">
                    <div class="d-flex align-items-center justify-content-center " style="box-shadow:rgb(0 0 0 / 20%) 1px 1px 5px 0; padding:0.75rem 0; border-radius:2px;">
                      <img src="@/assets/images/login/google-icon.svg" class="img-fluid mr-3" style="height:30px;">
                      <span style="color:#9fa1a4; font-size:18px; font-family:'Roboto', sans serif;">Acceder con Google</span>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col text-center">
                    <router-link to="/ingresar" tag="a">
                      <small class="footer-login">¡Ya tengo cuenta! Login</small>
                    </router-link>
                  </div>
                </div>

                <!-- Fin Campos de formulario -->
              </form>
            </div>
          </div>
          <div class="cotizarlo-general-wrapper" v-else>
            <div class="card-body px-5 pt-5 pb-4">
              <form>
                <div class="row mb-1">
                  <div class="col-8 offset-2 text-center">
                    <img src="@/assets/logo.svg" class="img-fluid" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <span>Verifica o modifica tus datos:</span>
                  </div>
                </div>
                <!-- Campos de formulario -->
                <div class="row mt-4">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-icon-container login">
                        <input type="email" placeholder="Usuario / e-mail" :class="{ 'is-invalid': $v.social_register.email.$error }" id="email" v-model="social_register.email" autocomplete="new_email" readonly/>
                        <i class="icon icon-cot-usuario"></i>
                      </div>
                      <small class="form-text text-danger mt-1" v-show="!$v.social_register.email.email">Ingresa un email válido.</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.social_register.name.$error }">
                        <input type="text"  class="main-input" id="name_social" v-model="social_register.name" placeholder="_" autocomplete="new_name" required/>
                        <label class="main-label" for="name_social">Nombre*</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <div class="input-field login" :class="{ 'is-invalid': $v.social_register.last_name.$error }">
                        <input type="text"  class="main-input" id="last_name_social" v-model="social_register.last_name" placeholder="_" autocomplete="new_last_name" required/>
                        <label class="main-label" for="last_name_social">Apellidos*</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-field login">
                        <input type="text" class="main-input icon" id="company_social" v-model="social_register.company" placeholder="_" autocomplete="new_company" required/>
                        <label class="main-label icon" for="company_social">Nombre de empresa</label>
                        <i class="far fa-building icon-input" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <hollow-dots-spinner v-if="loadingCountries" dark style="height: 25px; margin: 15px auto;" />
                      <div v-else class="input-field login" :class="{ 'is-invalid': $v.social_register.country_id.$error }">
                        <i class="icon-input far fa-map"></i>
                        <select id="country" v-model="social_register.country_id" class="main-input icon" required :disabled="loadingCountries">
                          <option disabled selected :value="null">Selecciona pais</option>
                          <option v-for="country in countries" :key="'country-' + country.id" :value="country.id">{{ country.name }}</option>
                        </select>
                        <label class="main-label icon" for="country">Pais*</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group form-check">
                      <input type="checkbox" class="form-check-input" :class="{'is-invalid': $v.social_register.terms.$error}"  id="terms" v-model="social_register.terms">
                      <label class="cot-reg-check-label" for="terms">
                        Al crear tu cuenta aceptas plenamente los 
                        <a href="https://www.cotizarlo.com/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a> 
                        así como nuestro 
                        <a href="https://www.cotizarlo.com/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <button type="button" class="btn form-control cot-login-btn" @click="doRegister()" :disabled="!social_register.terms || loadingRegister">
                      <hollow-dots-spinner v-if="loadingRegister" />
                      <span v-else>Crear cuenta</span>
                    </button>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col text-center">
                    <router-link to="/ingresar" tag="a">
                      <small class="footer-login">¡Ya tengo cuenta! Login</small>
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-center">
                <a href="https://www.cotizarlo.com/aviso-de-privacidad" class="btn btn-link text-login terms" target="_blank">Política de Privacidad</a>
                <div style="width:10px; height:10px; border-radius:50%; background:white;"></div>
                <a href="https://www.cotizarlo.com/terminos-y-condiciones" class="btn btn-link text-login terms" target="_blank">Términos y Condiciones</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import methods from '@/mixins/methods'
import { Auth, providerGoogle } from "@/firebase";
import { validationMixin } from 'vuelidate'
import { required, email, minLength, sameAs, numeric } from 'vuelidate/lib/validators';
import AuthService from "@/api/auth";

import HollowDotsSpinner from '@/components/Common/HollowDotsSpinner.vue';

export class SocialLoginResponse {
    isNewUser = false;
    image = null;
    birthdate = null;
    name = null;
    socialId = null;
    email = null;
    provider = null;
}

export default {
  components: { HollowDotsSpinner },
  mixins: [ validationMixin, methods ],
  created() {
    this.fetchCountries();
  },
  mounted(){
    var script = document.createElement('script')
    script.id = "recaptchaScript"
    script.setAttribute('async', '')
    script.setAttribute('defer', '')
    script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=6Leukb4UAAAAANVHkKofr3JR2vy7U_NiqKNZiYxD');
    this.scriptFile = document.head.appendChild(script);
  },
  beforeDestroy() {
    document.getElementById('recaptchaScript').remove()
    document.getElementsByClassName("grecaptcha-badge")[0].parentElement.remove()
    document.querySelectorAll(`[src*="recaptcha"]`)[0].remove()
  },
  data() {
    return {
      normal_register:{
        name: null,
        last_name: null,
        email: null,
        password: null,
        verify: null,
        terms: false,
        company: "",
        country_id: null
      },
      social_register:{
        name: null,
        last_name: null,
        email: null,
        terms: false,
        company: "",
        google_id:"",
        country_id: null
      },
      isGoogleUser: false,
      countries: [],
      loadingCountries: true,
      loadingRegister: false,
      error: null
    }
  },

  validations: {
    normal_register:{
      name: { required },
      last_name: { required },    
      email: { required, email },
      password: { required, minLength: minLength(6) },
      verify: { required, sameAsPassword: sameAs('password') },
      country_id: { required, numeric },
      terms: {
        checked: value => value === true
      }
    },
    social_register:{
      name: { required },
      last_name: { required },
      email: { required, email },
      google_id: { required },
      country_id: { required, numeric },
      terms: {
        checked: value => value === true
      }
    }
  },

  methods: {
    generateToken(){
      var that = this;
      return new Promise( (resolve,reject)=>{
        window.grecaptcha.execute('6Leukb4UAAAAANVHkKofr3JR2vy7U_NiqKNZiYxD', {action: 'register'}).then(function(token) {
          that.validateToken(token).then((responseToken)=>{
            resolve(responseToken);
          })
        }).catch((error)=>{
          this.$store.dispatch('showMessage',{
            action:'error',
            message:error
          });
          reject(error)
        });
      } )
      
    },
    validateToken(token){
      let data = {
        response: token
      }
      return new Promise( (resolve,reject)=>{
        AuthService.validateTokenRecaptcha(data).then(
        (response) => {
          resolve(response);
        }
        ).catch(()=>{
          reject(false);
        })
      })
    },
    doRegister(){
      if(this.isGoogleUser){
        this.$v.social_register.$touch()
        if (this.$v.social_register.$invalid) {
          this.$store.dispatch("showMessage", {
            action: "error",
            message: "Por favor revisa todos los campos",
          });
        }else{
          this.loadingRegister = true;
          this.generateToken().then(
            ()=>{
              this.$store.dispatch("client/register", this.$data.social_register).then(
                () => {
                  this.$store.dispatch('client/setData').then(
                    () => {
                      
                      if(localStorage.getItem('tokenInvitation') != undefined){
                        setTimeout(() => {
                          this.$router.replace({name:'clientInvitation',  query: { token: localStorage.getItem('tokenInvitation') } });
                        }, 500);
                      }else{
                        localStorage.removeItem('tokenInvitation');
                        setTimeout(() => {
                          this.$router.push({name:'clientConfigCompany',query: { welcome: 'true' }});
                        }, 500);
                      }
                    }
                  ).catch(
                    ()=>{
                      this.loadingRegister = false;
                      this.$store.dispatch('showLoader',{show:false});
                    }
                  )
                }
              )
            }
          )
        }
      }else{
        this.$v.normal_register.$touch()
        if (this.$v.normal_register.$invalid) {
          this.$store.dispatch("showMessage", {
            action: "error",
            message: "Por favor revisa todos los campos",
          });
        }else{
          this.loadingRegister = true;
          this.generateToken().then(
            ()=>{
              this.$store.dispatch("client/register", this.$data.normal_register).then(
                () => {
                  this.$store.dispatch('client/setData').then(
                  () => {
                    if(localStorage.getItem('tokenInvitation') != undefined){
                      setTimeout(() => {
                        this.$router.replace({name:'clientInvitation',  query: { token: localStorage.getItem('tokenInvitation') } });
                      }, 500);
                    }else{
                      localStorage.removeItem('tokenInvitation');
                      setTimeout(() => {
                        this.$router.push({name:'clientConfigCompany'});
                      }, 500);
                    }
                  }
                ).catch(
                  ()=>{
                    this.loadingRegister = false;
                    this.$store.dispatch('showLoader',{show:false});
                  }
                )
                }
              ).catch(
                (error)=>{
                  this.loadingRegister = false;
                  if(error.email_verified != undefined){
                    this.$store.dispatch('showMessage', { action: 'error', message: "Correo sin verificar"})
                    this.$router.push({name:'clientResendEmail' , params:{data:error}});
                  }
                  
                }
              )
            }
          )
          
        }
      }  
    },
    doRegisterSocial() {
      Auth.signInWithPopup(providerGoogle)
      .then((result) => {
        let responseGoogle = this.handleGoogleResponse(result)
        this.isGoogleUser = true;
        this.social_register.email = responseGoogle.email;
        this.social_register.name = responseGoogle.name;
        this.social_register.last_name = responseGoogle.last_name;
        this.social_register.google_id = responseGoogle.socialId;
      })
      .catch(
        () => this.$store.dispatch('showLoader',{show:false})
      );
    },
    handleGoogleResponse(responseFacebook){
      let temp = new SocialLoginResponse();
      let response = responseFacebook.additionalUserInfo;
      if( response != undefined){
          temp.isNewUser = response.isNewUser;
          temp.email = response.profile.email;
          temp.image = response.profile.picture;
          temp.name = response.profile.given_name;
          temp.last_name = response.profile.family_name;
          temp.socialId = response.profile.id;
          temp.provider = "google";
      }
      return temp;
    },
    async fetchCountries() {
      this.loadingCountries = true;

      const countriesPromise = AuthService.countries();

      try {
        const [countriesResponse] = await Promise.all([countriesPromise]);
        this.countries = countriesResponse.status === 204 ? [] : countriesResponse.data;
      } catch(e) {
        this.error = e;
      }

      this.loadingCountries = false;
    }
  }
}
</script>
